
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, Music, Download, ThumbsUp } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';

const HeroSection: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Check auth state on component mount
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data } = await supabase.auth.getSession();
        setIsAuthenticated(!!data.session);
      } catch (error) {
        console.error('Error checking auth status:', error);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();

    // Subscribe to auth changes
    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAuthenticated(!!session);
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  // Function to scroll to top on navigation
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-background to-background/80"></div>
        <div className="absolute top-0 left-0 right-0 h-[500px] bg-[radial-gradient(circle_at_center,rgba(29,185,84,0.1),transparent_40%)]"></div>
      </div>

      <div className="container relative z-10 px-4 py-6 mx-auto text-center sm:px-6 lg:px-8 min-h-[70vh] flex flex-col justify-center">
        <h1 className="max-w-4xl mx-auto text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl animate-slide-up [animation-delay:100ms] opacity-0">
          <span className="text-spotify-green">Grow</span> Your Fanbase, <span className="text-spotify-green">Reward</span> Your Listeners
        </h1>
        
        <p className="max-w-xl mx-auto mt-6 text-lg text-muted-foreground animate-slide-up [animation-delay:200ms] opacity-0">
          Reward fans with exclusive downloads and watch your Spotify listeners skyrocket 🚀
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4 mt-10 animate-slide-up [animation-delay:300ms] opacity-0">
          {!isLoading && (
            isAuthenticated ? (
              <Link to="/dashboard" onClick={scrollToTop}>
                <Button size="lg" className="group">
                  Go to Dashboard
                  <ArrowRight size={16} className="ml-2 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
            ) : (
              <Link to="/register" onClick={scrollToTop}>
                <Button size="lg" className="group">
                  Start My FREE Trial
                  <ArrowRight size={16} className="ml-2 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
